import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Injector, input, OnDestroy, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { Subscription } from 'rxjs';

type InputRadioValue = string | boolean | number;
export interface InputRadioOption {
  label: string;
  value: InputRadioValue;
}
@Component({
  selector: 'app-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputRadioComponent,
      multi: true,
    },
  ],

  imports: [RadioButtonModule, FormsModule],
})
export class InputRadioComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {
  private injector = inject(Injector);
  private subscription: Subscription | null = null;

  options = input.required<InputRadioOption[]>();
  label = input<string>();

  disabled = signal<boolean>(false);

  onChanged?: (value: InputRadioValue) => void;
  onTouched: () => void = () => {};
  value = signal<InputRadioValue>('');

  ngAfterViewInit() {
    setTimeout(() => {
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl?.control) {
        this.subscription = ngControl.control.valueChanges.subscribe(newValue => {
          this.value.set(newValue ?? '');
        });
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  writeValue(value: InputRadioValue) {
    this.value.set(value ?? '');
  }

  registerOnChange(fn: (value: InputRadioValue) => void) {
    this.onChanged = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  onRadioInputChange(option: InputRadioOption): void {
    if (this.disabled()) {
      return;
    }

    this.value.set(option.value);
    if (this.onChanged) {
      this.onChanged(option.value);
    }
    this.onTouched();
  }
}
